const DEFAULT_SESSION_EXPIRATION_IN_SECONDS = "900"; // default to 15 minutes

export { DEFAULT_SESSION_EXPIRATION_IN_SECONDS };
//# sourceMappingURL=constants.mjs.map
